/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, IconButton } from '@material-ui/core'
import { Delete, Edit } from '@material-ui/icons'

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})


const styles = theme => ({

})

class RecoSource extends Component {
    state = {  }

    getClassificationText = () => {
        if (this.props.source.show_class === null) {
            return "Unavailable"
        } else if (this.props.source.show_class === true) {
            return "Yes"
        } else if (this.props.source.show_class === false) {
            return "No"
        }
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <Paper variant = 'outlined' style = {{width : '100%', padding : '10px', marginBottom : '5px', backgroundColor : '#F0F0F0'}}>
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <div style = {{padding : '5px', flexGrow : 1}}>
                            <Typography variant = 'subtitle2' color = 'primary'>Information Channel</Typography>
                            <Typography variant = 'body2'>{this.props.source.ic_name}</Typography>
                        </div>
                        <div style = {{padding : '5px', flexGrow : 1}}>
                            <Typography variant = 'subtitle2' color = 'primary'>Showing Classification Results</Typography>
                            <Typography variant = 'body2'>{this.getClassificationText()}</Typography>
                        </div>
                        <div style = {{marginRight : '15px'}}>
                            <IconButton size = 'small' onClick = {() => this.props.select_source(this.props.source.ic_name)}>
                                <Edit fontSize = 'small'/>
                            </IconButton>
                        </div>
                        <div>
                            <IconButton size = 'small' color = 'secondary' onClick = {() => this.props.delete_source(this.props.source.ic_name)}>
                                <Delete fontSize = 'small'/>
                            </IconButton>
                        </div>
                    </div>  
                </Paper>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(RecoSource);